module.exports = __webpack_public_path__ + "static/media/announce1.8d448c34.jpg";